// Ülke Kodu -> { resmiDil, paraBirimi, zamanDilimi }
// Bu yapı, IP'den gelen ülke koduna göre hangi ayarların seçileceğini belirler.
export const countryData = {
  'TR': { language: 'tr', currency: 'TRY', timezone: 'Europe/Istanbul' },
  
  // Euro Bölgesi
  'DE': { language: 'de', currency: 'EUR', timezone: 'Europe/Berlin' },
  'FR': { language: 'fr', currency: 'EUR', timezone: 'Europe/Paris' },
  'IT': { language: 'it', currency: 'EUR', timezone: 'Europe/Rome' },
  'ES': { language: 'es', currency: 'EUR', timezone: 'Europe/Madrid' },
  'AT': { language: 'de', currency: 'EUR', timezone: 'Europe/Vienna' },
  'BE': { language: 'fr', currency: 'EUR', timezone: 'Europe/Brussels' },
  'NL': { language: 'nl', currency: 'EUR', timezone: 'Europe/Amsterdam' },
  'IE': { language: 'en', currency: 'EUR', timezone: 'Europe/Dublin' },
  'PT': { language: 'pt', currency: 'EUR', timezone: 'Europe/Lisbon' },
  'GR': { language: 'el', currency: 'EUR', timezone: 'Europe/Athens' },
  
  // Diğer Önemli Ülkeler
  'GB': { language: 'en', currency: 'GBP', timezone: 'Europe/London' },
  'US': { language: 'en', currency: 'USD', timezone: 'America/New_York' },
  'CA': { language: 'en', currency: 'CAD', timezone: 'America/Toronto' },
  'AU': { language: 'en', currency: 'AUD', timezone: 'Australia/Sydney' },
  'RU': { language: 'ru', currency: 'RUB', timezone: 'Europe/Moscow' },
  'SA': { language: 'ar', currency: 'SAR', timezone: 'Asia/Riyadh' },
  'JP': { language: 'ja', currency: 'JPY', timezone: 'Asia/Tokyo' },
  'CN': { language: 'zh', currency: 'CNY', timezone: 'Asia/Shanghai' },
};

// DEĞİŞİKLİK: Sitenin desteklediği dillerin listesi.
// Bu liste, bir dilin arayüzde seçilip seçilemeyeceğini belirler.
export const supportedLanguages = ['tr', 'en'];